const riot = require('riot');

riot.tag2('page-workspace-users-management', '<div class="h-full f fclm"> <div data-is="module-header" title="ユーザータスク一覧" back="{true}"></div> <div class="f fclm s-full"> <div class="f fm px24 mb24"> <button class="flex-fixed button h50 deep flex-fixed f fm cursor-pointer mr32" onclick="{onOpenPopupSuggestionUsers}">選択</button> <div class="f fm overflow-x-scroll py12 scrollbar-none"> <div class="relative w100 flex-fixed rounded-8 p6 h50 bg-white box-shadow-primary mr16" each="{user in getSelectedUsers()}"> <div class="f fm fclm"><img class="s25 circle object-fit-cover border border-white" riot-src="{app.utils.getImageUrl(user.data.icon_image)}"><span class="fs12 line-clamp-1 word-break-all lh13">{user.data.screen_name}</span></div><i class="icon-close p2 circle bg-white hover-trigger hover-opacity-80 text-primary border absolute tn6 rn6 f fh fs16 cursor-pointer" onclick="{onRemoveUser}"></i> </div> </div> </div> <div class="px24 mb24" if="{userNoteItems.length}"> <div class="flex-fixed f fm mr8"> <button class="f fm bg-white box-shadow-primary py3 px10 hover-trigger hover-bg-pale hover-text-label_dark_primary rounded-8 p4 fs12" onclick="{onOpenProjectPopup}"> <div class="flex-fixed s24 rounded-8 overflow-hidden mr8"> <div class="s-full" if="{!project?.data?.icon_image?.url}" riot-style="background-color: {getProjectBgColor()}"></div><img class="s-full object-fit-cover" if="{project?.data?.icon_image?.url}" riot-src="{app.utils.getImageUrl(project?.data?.icon_image)}"> </div> <div class="line-clamp-1 word-break-all word-keep-all lh15 mr2">{project ? project.data.name : ⁗全てのプロジェクト⁗}</div><i class="icon-arrow-down fs10 text-label_dark_medium pt6 pb4 px4"></i> </button> </div> </div> <div class="s-full f overflow-x-scroll px16 pb16"> <div class="flex-fixed w270 h-full bg-white rounded-8 mr16" each="{item in userNoteItems}"> <div class="f flex-column s-full" data-is="item-user-notes-column" notes="{item.notes}" user="{item.user}"></div> </div> <div class="f fh s-full bg-white rounded-16 box-shadow-primary p16" if="{!userNoteItems.length &amp;&amp; !indicator}"> <div class="f fm fclm"> <div class="fs20 mb16">ユーザーを選択してください</div> <div class="mb16">選択したユーザーのノートを表示できます。</div> <div class="mb64">ドラッグ&ドロップでユーザーのアサインを変更できます。</div> <h4 class="fs16 mb16">個別で選択</h4> <button class="button deep h40 flex-fixed f fm cursor-pointer mb32" onclick="{onOpenPopupSuggestionUsers}">選択</button> <h4 class="fs16 mb16">グループから選択</h4> <div class="h40vh w40vw overflow-y-scroll px16" if="{formatWorkspaceGroups().length}"> <div class="f fbw fm lh18 hover-trigger hover-border-primary transition-128 hover-box-shadow hover-text-primary cursor-pointer h48 rounded-8 border border-separator_opacity pl16 pr8 mb8 mb0-last" each="{item in formatWorkspaceGroups()}" onclick="{onGroupClick}"> <div class="line-clamp-1 word-break-all fs13 bold mr16">@{item.data.screen_name}</div> <div class="f fm"> <div class="f w100 h20 mr10 overflow-x-scroll scrollbar-none {item.data.user_ids.length &gt; GROUP_MEMBER_DISPLAY_RANGE ? &quot;&quot; : &quot;fr&quot;}"> <div class="circle s20 flex-fixed overflow-hidden border border-white bg-white" each="{user in getGroupUsers(item)}"><img class="s-full object-fit-cover cursor-pointer" riot-src="{app.utils.getImageUrl(user.data.icon_image)}"></div> </div> <div class="word-break-keep mr8" ref="group" onmouseenter="{showTooltipUsers}"><span class="bold fs13 mr2">{item.data.user_ids.length}</span><span class="fs10">人</span></div> </div> </div> </div> <div class="f fm fclm" if="{!workspacesGroups?.length}"> <div class="s50 py8" data-is="atom-loading"></div> </div> </div> </div> </div> </div> <div class="flex-fixed w-full s-show" if="{!app.utils.isKeyboardOpen()}" data-is="module-tabbar"></div> </div>', 'page-workspace-users-management,[data-is="page-workspace-users-management"]{display:block}', '', function(opts) {
    const GROUP_MEMBER_DISPLAY_RANGE = 12;
    this.selectedUsers = [];
    this.selectedUsersIds = [];
    this.userNoteItems = [];
    this.workSpaceGroups = [];
    this.project = null;

    this.onGroupClick = (e) => {
      const group = e.item.item;

      this.selectedUsersIds = group.data.user_ids;
      this.search();
    };

    this.on('mount', () => {

      this.selectedUsers = [];
      this.selectedUsersIds = [];
      this.userNoteItems = [];
      this.workSpaceGroups = [];
    });

    this.getUniqueProjectColumns = async () => {
      const project_columns = await this.getProjectColumns();
      const unique_columns = app.utils.unique(project_columns, c => c.data.name);
      return unique_columns;
    };

    this.getWorkspaceAllColumns = async () => {
      if (this._workspaceAllColumns) return this._workspaceAllColumns;
      const projects_users = app.store.projectsUsersStore.items.filter(item => !item.data.archived);
      const columns_list = await Promise.all(projects_users.map(async pu => {
        if (!pu.data) await pu.fetch();
        return app.store.doc(pu.data.project_ref.path).fetchColumns();
      }));
      this._workspaceAllColumns = columns_list.flat();
      return this._workspaceAllColumns;
    };

    this.getProjectColumns = async () => {
      const project_id = this.project?.id;
      const all_columns = await this.getWorkspaceAllColumns();
      const project_columns = project_id ? all_columns.filter(c => c.getProject().id === project_id) : all_columns;
      return project_columns;
    };

    this.onOpenPopupSuggestionUsers = async (e) => {
      e.preventDefault();
      e.stopPropagation();

      let selected = false;

      const popup = spat.popup.open('popup-suggestion-users', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        offsetTop: 16,
        position: 'bottom',
        opts: {
          label: 'ユーザーを選択',
          users: this.users,
          selectedUsersIds: this.selectedUsersIds,
        },
      });

      popup.on('userselect', async ({ user, checked }) => {
        selected = true;
        this.update();
      });

      popup.on('close', async () => {
        this.selectedUsers = popup.getSelectedUsers();
        this.selectedUsersIds = this.selectedUsers.map(user => user.id);

        if (!selected) return;
        this.search();
        this.update();
      });
    };

    this.search = async () => {
      this.indicator = spat.modal.indicator();
      if (!this.selectedUsersIds.length) {
        const message = 'ユーザーを選択してください。';
        spat.toast.message(message, { icon: "mypage"});
        return;
      }

      this.update({
        userNoteItems: [],
      });

      let promises = this.selectedUsersIds.map(async (user_id) => {
        const user = this.users?.find(u => u.id === user_id);
        const param = {

          assigned_user_id: user_id,

          project_id: this.project?.id,
          limit: 64,
        };

        const ignore_column = 'close';
        const columns = await this.getProjectColumns();
        const column_name_set = new Set(ignore_column.split(',').map(c => c.trim()).filter(c => c));

        param.ignore_column_ids = columns.filter(c => column_name_set.has(c.data.name)).map(c => c.id).join(',');

        const { note_refs } = await app.api.child('workspaces').child(this.workspace_id).child('projects/search_note').post(param);
        const user_notes = await Promise.all(note_refs.map((path) => app.store.doc(path).fetch()));
        const notes = await this.formatNotes(user_notes);

        if (user?.id) {
          this.userNoteItems.push({
            user,
            notes,
          });
        }
      });

      try {
        await Promise.all(promises);
      }
      finally {
        this.indicator.close();
        this.indicator = null;
      }
      this.update();
    };

    this.formatNotes = async (notes) => {

      const items = await Promise.all(
        notes.map(async (note) => {
          const project = await note.getProject();
          note.project = project;
          return note;
        })
      );

      const projects_count = items.reduce((acc, note) => {
        const project_id = note.project.id;
        acc[project_id] = (acc[project_id] || 0) + 1;
        return acc;
      }, {});

      items.sort((a, b) => {
        const count_a = projects_count[a.project.id];
        const count_b = projects_count[b.project.id];
        return count_b - count_a;
      });

      return items;
    };

    this.openPopupColumnFilter = async ({ title, value, target } = {}) => {

      const names = (value || '').split(',').map(v => v.trim()).filter(v => v);
      const columns = await this.getUniqueProjectColumns();
      const selected = names.map(name => columns.find(c => c.data.name === name)).filter(c => c);

      const result = await spat.popup.open('popup-column-filter', {
        element: target,
        closeTarget: target,
        offsetTop: 8,
        opts: {
          title,
          columns: columns,
          selectedColumns: selected,
        },
      }).waitClose();
      return result.map(c => c.data.name).join(',');
    };

        this.customFilters = [
      {
        id: 'column',
        label: 'カラム',
        tooltip: 'カラム名で絞り込み',
        action: (e) => this.customFilterColumnAction(e),
        actionArrowDown: (e) => this.customFilterColumnAction(e),
        toggle: ['ignore_column'],
      },
      {
        id: 'ignore_column',
        label: 'カラム除外',
        tooltip: '検索から除外するカラムを指定',
        action: (e) => this.customFilterIgnoreColumnAction(e),
        actionArrowDown: (e) => this.customFilterIgnoreColumnAction(e),
        toggle: ['column'],
      }
    ];

    this.head = () => {
      return {
        title: `ユーザータスク一覧 | ${spat.config.head.ogp.site_name}`,
      };
    };

    this.statusFilters = [
      {id: 'favorite', label: 'お気に入り'},
      {id: 'unassigned', label: '未アサイン', toggle: ['assigned']},
    ];

    this.preload = ({req, res}) => {
      return {
        workspace_id: req.params.workspace_id,
      };
    };

    this.on('show', async ({req, res}) => {
      this.selectedUsers = [];
      this.selectedUsersIds = [];
      this.userNoteItems = [];
      this.workSpaceGroups = [];
      this.project = null;

      await app.store.setup(req.params);

      const promises = [
        app.store.workspace.fetchWorkspaceUsers(),
        app.store.workspace.fetchGroups(),
      ];

      const [ workspaces_users, workspaces_groups ] = await Promise.all(promises);
      this.workspacesGroups = workspaces_groups;

      this.users = workspaces_users.map(tu => tu.relation.user);

      this.update();
    });

    this.formatWorkspaceGroups = () => {

      let group = this.workspacesGroups.filter(group => group.data.user_ids.length);

      group.sort((a, b) => b.data.user_ids.length - a.data.user_ids.length);
      return group;
    };

    this.getSelectedUsers = () => {
      return this.userNoteItems.map(item => item.user);
    };

    this.onRemoveUser = (e) => {
      const user_id = e.item.user.id;
      this.selectedUsersIds = this.selectedUsersIds.filter(id => id !== user_id);
      this.userNoteItems = this.userNoteItems.filter(item => item.user.id !== user_id);
    };

    this.onOpenProjectPopup = async (e) => {
      const popup = spat.popup.open('popup-suggestion-projects', {
        element: e.currentTarget,
        closeTarget: e.currentTarget,
        opener: this.root,
        position: 'bottom',
      });
      const value = await popup.waitClose();

      let prev_project = this.project;

      if (value) {

        if (value.type === 'all') {
          this.project = null;
        }
        else {

          this.project = value;
          await value.fetch();
          this.update();
        }
      }

      if (prev_project !== this.project) {
        this.search();
      }
    };

    this.getGroupUsers = (group) => {
      const users = group.data.user_ids.map(user_id => this.users.find(user => user.id === user_id));
      return users;
    };

    this.getProjectBgColor = () => {
      if (!this.project) return 'hsl(0, 0%, 90%)';
      return this.project.data?.color || `hsl(${app.utils.stringToColorAngle(this.project.data?.name)}, 50%, 70%)`;
    };
});